import PromoSingle from '../../promotion/PromoSingle';
import { useState } from "react";
import PropertyComment from '../../property/PropertyComment';
import { useParams } from "react-router-dom";

const PromoCustomerDetail = () => {
  const { Id } = useParams()
  const [ownerId, setOwnerId] = useState(null);
  
  return ( 
    <div className=" mb-4 pb-4"> 
      <PromoSingle 
        backbtn="/customer/promotions"
        ownerId={setOwnerId} 
      />
      <PropertyComment 
        Id={Id}
        ownerId={ownerId}
        commentType="promotionComments"
        allComments={`/property/requestPromotionComments`}
        addComment={`/property/addRequestPromotionComment`}
        editComment={`/property/editRequestPromotionComment`}
        deleteComment={`/property/deleteRequestPromotionComment/`}
      /> 
    </div>
  );
}

export default PromoCustomerDetail;
